import { swrSingleGetConfig } from "configs/swrConfig";
import { DashboardTransactionsDto } from "interfaces/interfaces";
import { useEffect } from "react";
import useSWR from "swr";

const useDashboard = () => {
  useEffect(() => {
    mutate();
  }, []);

  const fetcher = async (url: string) => {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${""}`,
      },
    });

    return await response.json();
  };
  const { data, isValidating, mutate } = useSWR<DashboardTransactionsDto>(`${process.env.REACT_APP_API_URL}/operator/dashboard`, fetcher, swrSingleGetConfig);

  return { data, isValidating, mutate };
};
export default useDashboard;
